export default __webpack_public_path__ + "static/media/magnify.f55b2efc.svg";